import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  icon: {
    opacity: 0.7,
    textTransform: 'none',
    margin: '8px 0 0 0',
  },
  box: {
    minWidth: 'max-content',
    marginLeft: '10px',
  },
  buttonInsertAll: {
    opacity: 0.8,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
  },
  primaryIconButton: {
    height: '36px',
    minWidth: '109px',
    fontWeight: '500',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
    '&:hover': {
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
    },
    textTransform: 'none',
    opacity: 1,
  },
  tooltip: {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  noAccess: {
    fontSize: '14px',
    color: theme.palette.primary.sideBarIconColor,
    textAlign: 'center',
    padding: '8px',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
  disabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
  lockIcon: {
    width: '0.84em',
    height: '0.84em',
    padding: '4px',
    '&:hover': {
      backgroundColor: '#3d3d3d0c',
      borderRadius: '50%',
    },
  },
};
